var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDragging
    ? _c(
        "div",
        { staticClass: "draggable-event", style: _vm.dragStyles },
        [
          _c(
            "Event",
            _vm._b(
              { attrs: { date: _vm.newDate || _vm.event.date } },
              "Event",
              _vm.event,
              false
            )
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }